import { render } from "./ZhaiJiuGongPC.vue?vue&type=template&id=65e6225c&scoped=true"
import script from "./ZhaiJiuGongPC.vue?vue&type=script&lang=js"
export * from "./ZhaiJiuGongPC.vue?vue&type=script&lang=js"

import "./ZhaiJiuGongPC.vue?vue&type=style&index=0&id=65e6225c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e6225c"]])

export default __exports__